import request from '@/utils/request'

// 检索式查询
export function competitorDatabaseSearch(data) {
  return request({
    url: '/bus/competitorLibrary/competitorDatabaseSearch',
    method: 'POST',
    data
  })
}
export function getFiles(data) {
  return request({
    url: '/bus/competitorLibrary/files',
    method: 'POST',
    data
  })
}